import { PublicRoutes } from "@/constants/routes";
import type { FAQItem } from "@/pages/landingPage/components";
import { HUB_CRUMB, webApplicationSchema } from "../constants";

export const PATH = PublicRoutes.FERRAMENTA_SIMULADOR_CREDIARIO;
// Sem o sufixo "| Fidexa": o titleTemplate de src/App.tsx acrescenta.
export const TITLE = "Simulador de Crediário: Parcelas, Juros e CET";
export const DESCRIPTION =
  "Simulador de crediário grátis para lojas: calcule parcela, juros, CET e tabela mês a mês pela Tabela Price e envie a simulação ao cliente no WhatsApp.";

export const TRAIL = [
  HUB_CRUMB,
  { name: "Simulador de crediário", path: PATH },
];

export const WEB_APPLICATION = webApplicationSchema({
  name: "Simulador de crediário",
  path: PATH,
  description: DESCRIPTION,
});

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "Como calcular a parcela do crediário com juros?",
    answer:
      "O crediário com parcelas iguais usa a Tabela Price: parcela = valor financiado × taxa × (1 + taxa)^n ÷ [(1 + taxa)^n − 1], com a taxa mensal em decimal e n como o número de parcelas. Por exemplo, R$ 2.000 em 10 vezes a 2% ao mês dá parcelas de cerca de R$ 222,65. O simulador faz essa conta e mostra quanto de cada parcela é juros e quanto abate a dívida.",
  },
  {
    question: "Qual a diferença entre taxa de juros e CET?",
    answer:
      "A taxa de juros remunera só o dinheiro emprestado. O custo efetivo total (CET) soma também as tarifas cobradas na venda, como uma tarifa de cadastro embutida nas parcelas. Sem tarifa, CET e taxa de juros são iguais; com tarifa, o CET fica acima, e é ele que mostra ao cliente quanto o crediário custa de fato.",
  },
  {
    question:
      "O que a loja precisa informar ao cliente numa venda no crediário?",
    answer:
      "O Código de Defesa do Consumidor (art. 52) exige que, na venda com financiamento, o cliente seja informado do preço à vista, do montante dos juros de mora e da taxa efetiva anual de juros, dos acréscimos previstos, do número e da periodicidade das prestações e da soma total a pagar. A simulação deste simulador traz esses números prontos para enviar.",
  },
  {
    question: "Quanto de multa a loja pode cobrar por parcela atrasada?",
    answer:
      "No crediário ao consumidor, a multa por atraso não pode passar de 2% do valor da prestação (CDC, art. 52, § 1º). Além da multa, podem correr juros de mora sobre os dias de atraso, conforme o que estiver no contrato.",
  },
];
